/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {provisionApplePay} from '../api'

export const useMutationProvisionApplePay = createReactQueryMutationHook('provisionApplePay', provisionApplePay)
